import React, { createContext, useState, useEffect, useCallback } from 'react';
import authTokenService from 'src/services/auth.service';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(() => sessionStorage.getItem('SUMMERYOU_TOKEN'));
    const [refreshToken, setRefreshToken] = useState(() => sessionStorage.getItem('SUMMERYOU_RETOKEN'));
    const [username, setUsername] = useState(() => sessionStorage.getItem('SUMMERYOU_USERNAME'));

  // Save token to sessionStorage when it changes
  useEffect(() => {
    if (token) {
      sessionStorage.setItem('SUMMERYOU_TOKEN', token);
    } else {
      sessionStorage.removeItem('SUMMERYOU_TOKEN');
    }

    if(refreshToken) {
        sessionStorage.setItem('SUMMERYOU_RETOKEN', refreshToken);
    }
    else {
        sessionStorage.removeItem('SUMMERYOU_RETOKEN');
    }

    if(username) {
        sessionStorage.setItem('SUMMERYOU_USERNAME', username)
    } else {
        sessionStorage.removeItem('SUMMERYOU_USERNAME')
    }
        
  }, [token, refreshToken, username]);

  // called after successful login.
  const login = useCallback(({token, refreshToken, username}) => {
    setToken(token);
    setRefreshToken(refreshToken);
    setUsername(username);
  }, []);

  const logout = useCallback(() => {
    setToken(null);
    setRefreshToken(null);
    setUsername(null)
  }, []);

  // sync token refreshes performed by apiClient
  const handleTokensUpdated = useCallback((newToken, newRefreshToken) => {
    setToken(newToken);
    /* Preserve the existing refresh token in the backend doesn't return replacement */
    if (newRefreshToken !== undefined)
      setRefreshToken(newRefreshToken);
  }, [])

  // register callbacks so authTokenService can update React state
  useEffect(() => {
    authTokenService.registerCallbacks(handleTokensUpdated);
    return () => {
    authTokenService.unregisterCallbacks?.();
  };
  }, [handleTokensUpdated])
  const isLoggedIn = !!token;

  return (
    <AuthContext.Provider value={{ token, refreshToken, username, login, logout, isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};
